<template>
  <footer class="site-footer">
    <div class="wrap">
      <div class="foot">
        <div>
          <router-link to="/" class="brand">EIKA<span class="dot">.</span></router-link>
          <p class="foot-tag">Crafted interiors, quietly considered.</p>
        </div>
        <div class="foot-links">
          <router-link to="/about">About</router-link>
          <router-link to="/services">Services</router-link>
          <router-link to="/projects">Projects</router-link>
          <router-link to="/contact">Contact</router-link>
        </div>
      </div>
      <div class="foot-badges">
        <img
          v-for="b in badges"
          :key="b.alt"
          class="foot-badge"
          :src="b.src"
          :alt="b.alt"
        />
      </div>
      <div class="foot-legal">
        <!-- <div class="foot-legal-item">
          <span class="foot-legal-label">Incorporated</span>
          <span class="foot-legal-value">12 Jun 1999</span>
        </div> -->
        <div class="foot-legal-item">
          <span class="foot-legal-label">UEN</span>
          <span class="foot-legal-value">52894879B</span>
        </div>
      </div>
      <div class="foot-base">
        <span>© {{ year }} EIKA Interiors. All rights reserved.</span>
        <span>Let's craft your way of living.</span>
      </div>
    </div>
  </footer>
</template>

<script>
import { img } from "@/utils/projectImages";

export default {
  name: "TheFooter",
  data() {
    return {
      year: new Date().getFullYear(),
      badges: [
        { src: img("HDB_Authorised_Eika"), alt: "HDB Licensed Renovation Contractor — HB-09-3530D" },
        { src: img("SME500_2021_Trademark_Authorised"), alt: "SME 500 Singapore 2021–2022" },
        { src: img("SME500_2021_Trademark_Authorised_02"), alt: "Recognised as Singapore's 500 SME for the Year 2021" },
        { src: img("member-01"), alt: "Association of Trade & Commerce (Singapore) — Accredited Member" },
      ],
    };
  },
};
</script>
